import { Helmet } from "react-helmet-async";

const SITE_NAME = "Petraloc";
const SITE_URL = "https://www.petraloc.com";
const DEFAULT_OG_IMAGE = "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1200&q=70";

/**
 * Reusable SEO head component.
 * Drop <Seo title="..." description="..." path="/services" /> at the top of any page.
 */
export default function Seo({
  title,
  description,
  path = "",
  image = DEFAULT_OG_IMAGE,
  type = "website",
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} · Global Language Intelligence`;
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
